import React, { useRef } from 'react';

import './view.scss';
import {
    useQueryParam,
    StringParam,
    withDefault
} from 'use-query-params';

const URL_PARAMS_SEARCH_NAME = 'search';

export const ArticlesSearch = () => {
    const inputRef = useRef();
    const [searchParams, setSearchParams] = useQueryParam(URL_PARAMS_SEARCH_NAME, withDefault(StringParam, undefined));

    const handleInput = (e) => setSearchParams(e.target.value);

    const handleDeleteInput = () => setSearchParams('');

    const blurOnSubmit = () => inputRef?.current?.blur();

    return (
        <section className="articles-search">
            <form
                onSubmit={ (e) => {
                    e.preventDefault();
                    blurOnSubmit();
                } }
            >
                <input
                    ref={ inputRef }
                    inputMode="search"
                    className="articles-search__input"
                    placeholder="Wyszukaj artykuły"
                    onChange={ (e) => handleInput(e) }
                    value={ searchParams || '' }
                    type="text"
                />
            </form>
            { searchParams && <button className="articles-search__button" onClick={ () => handleDeleteInput() } type="button">&#10005;</button> }
        </section>
    );
};